<template>
  <div id="app">
    <component :is="activeComponent"></component>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { UI_LAYOUT_GET, LAYOUT_DEFAULT, LAYOUT_AUTH } from "Shared/store/ui";
import LayoutDefault from "Public/layouts/Default";
import LayoutAuth from "Public/layouts/Auth";

export default {
  name: "app",
  components: {
    [LAYOUT_DEFAULT]: LayoutDefault,
    [LAYOUT_AUTH]: LayoutAuth,
  },
  computed: {
    ...mapGetters({
      layout: UI_LAYOUT_GET,
    }),
    activeComponent() {
      return this.layout;
    },
  },
};
</script>
